/**
 * Lightweight pub/sub for license-related 403 responses from the auth API.
 * Avoids coupling axios interceptors to React directly.
 */

type License403Listener = (detail: string) => void;

const listeners = new Set<License403Listener>();

export function subscribeLicense403(listener: License403Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitLicense403(detail: string): void {
  listeners.forEach((l) => {
    l(detail);
  });
}
